var map = {
	"./account.js": "./src/store/modules/account.js",
	"./alert.js": "./src/store/modules/alert.js",
	"./assets.js": "./src/store/modules/assets.js",
	"./brief/brief-cn.js": "./src/store/modules/brief/brief-cn.js",
	"./brief/brief-etf.js": "./src/store/modules/brief/brief-etf.js",
	"./brief/brief-hk.js": "./src/store/modules/brief/brief-hk.js",
	"./brief/brief-us.js": "./src/store/modules/brief/brief-us.js",
	"./brief/brief.js": "./src/store/modules/brief/brief.js",
	"./discovery/disco-cn.js": "./src/store/modules/discovery/disco-cn.js",
	"./discovery/disco-hk.js": "./src/store/modules/discovery/disco-hk.js",
	"./discovery/disco-us.js": "./src/store/modules/discovery/disco-us.js",
	"./discovery/discovery.js": "./src/store/modules/discovery/discovery.js",
	"./heatmap.js": "./src/store/modules/heatmap.js",
	"./index.js": "./src/store/modules/index.js",
	"./indices.js": "./src/store/modules/indices.js",
	"./message.js": "./src/store/modules/message.js",
	"./metrics.js": "./src/store/modules/metrics.js",
	"./mqtt.js": "./src/store/modules/mqtt.js",
	"./news.js": "./src/store/modules/news.js",
	"./notification.js": "./src/store/modules/notification.js",
	"./option.js": "./src/store/modules/option.js",
	"./orders.js": "./src/store/modules/orders.js",
	"./quote/historyList.js": "./src/store/modules/quote/historyList.js",
	"./quote/quoteNews.js": "./src/store/modules/quote/quoteNews.js",
	"./quote/rankList.js": "./src/store/modules/quote/rankList.js",
	"./quote/views.js": "./src/store/modules/quote/views.js",
	"./quote/watchlist/watchlist-actions.js": "./src/store/modules/quote/watchlist/watchlist-actions.js",
	"./quote/watchlist/watchlist-futures.js": "./src/store/modules/quote/watchlist/watchlist-futures.js",
	"./quote/watchlist/watchlist-groups.js": "./src/store/modules/quote/watchlist/watchlist-groups.js",
	"./quote/watchlist/watchlist-holding.js": "./src/store/modules/quote/watchlist/watchlist-holding.js",
	"./quote/watchlist/watchlist.js": "./src/store/modules/quote/watchlist/watchlist.js",
	"./route.js": "./src/store/modules/route.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./sideEffects.js": "./src/store/modules/sideEffects.js",
	"./stock.js": "./src/store/modules/stock.js",
	"./timegap.js": "./src/store/modules/timegap.js",
	"./trade.js": "./src/store/modules/trade.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync recursive \\.js$";